import React from 'react';
import { Box, Typography, Stack, IconButton, Container } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: '#edf1fa',
        color: '#333',
        py: 2,
        borderTop: '1px solid #ddd',
        width: '100%',
        mt: 'auto', // Ensures the footer pushes to the bottom when there’s insufficient content
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: {
            xs: 2,
            sm: 3,
          },
        }}
      >
        {/* Left-aligned text */}
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.875rem',
            fontWeight: 400,
          }}
        >
          © {new Date().getFullYear()} CloudSec Network.
        </Typography>

        {/* Right-aligned social media icons */}
        <Stack direction="row" spacing={1}>
          <IconButton
            href="https://github.com/cloudsecnetwork"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ color: '#333' }}
          >
            <GitHubIcon />
          </IconButton>
          <IconButton
            href="https://linkedin.com/company/cloudsecnetwork"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ color: '#333' }}
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            href="https://twitter.com/cloudsecnetwork"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ color: '#333' }}
          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            href="https://instagram.com/cloudsecnetwork"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ color: '#333' }}
          >
            <InstagramIcon />
          </IconButton>
        </Stack>
      </Container>
    </Box>
  );
}

export default Footer;
